module.exports = __webpack_public_path__ + "static/media/IMG_3460.09fee9f1.JPG";